module.exports = __webpack_public_path__ + "img/FGr_Trinkwasser_A.73a289ab.svg";